import router from '../services/router_service';
import newslettersController from '../controllers/newsletters_controller';

router.on('route:newsletters', newslettersController);
